var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({staticClass:"akn-select",attrs:{"dense":"","filled":"","flat":"","color":_vm.isDarkMode ? 'grey lighten-5' : 'primary',"item-color":_vm.isDarkMode ? 'grey lighten-5' : 'primary',"menu-props":{ offsetY: true },"rounded":""}},'v-select',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }